import request from '@/utils/request';
import { Config } from './config';

// 1. 定义基础路劲
const BASE_URL = Config.restUrl;
// const BASE_URL = 'http://192.168.18.80:7009';

// 获取沟通详情
export function getInterviewRecordsDetail(id) {
  return request({
    url: `${BASE_URL}infrastructure_oa/interview_records/${id}`,
    method: 'get',
  });
}

// 钉消息获取沟通详情
export function getInterviewRecordsDetailFromDingMessage(itemUserID) {
  return request({
    url: `${BASE_URL}infrastructure_oa/interview_records/get_by_item_user/${itemUserID}`,
    method: 'get',
  });
}

// 主责任人确认完成
export function submitInterviewRecords(id, postData) {
  return request({
    url: `${BASE_URL}infrastructure_oa/interview_records/item_user/submit/${id}`,
    method: 'put',
    data: postData,
  });
}